import useShare from "utils/wechat/useShare"
import useConfig from "utils/wechat/useConfig"

/**
 * 课程页分享配置
 * @param config
 */
export default function Share({ config }) {
    const { wechatReady } = useConfig()
    useShare(wechatReady, config)

    return null
}